import React from 'react';
import InpageBase from './InpageBase';

import TInpage from './types/TInpage';
import { FeedbackSignals } from '../../types/TEFeedbackSignal';

const Warning = (props: TInpage) => <InpageBase {...props} signal={FeedbackSignals.Warning} />;

export default Warning;
